import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Login from './Pages/Login';
import WebScraper from './Pages/Webscraper';
import Profile from './Pages/Profile'; // Import the Profile component
import ProtectedRoute from './components/ProtectedRoute';
import Signup from './Pages/Signup';
import Home from './Pages/Home';

const App = () => {
    return (
        <AuthProvider>
            <Router>
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/sign-up" element={<Signup />} />
                    <Route element={<ProtectedRoute />}>
                        <Route path="/scraper" element={(
                            <div className="text-2xl text-center">
                                <WebScraper />
                            </div>
                        )} />
                        <Route path="/profile" element={<Profile />} />
                    </Route>
                    {/* Add other routes here */}
                </Routes>
            </Router>
        </AuthProvider>
    );
};

export default App; 